import React, { useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { Spinner } from './ui/shadcn-io/spinner'
import { toast } from 'sonner'

interface AlertProps {
  trigger: React.ReactNode
  title?: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm?: () => Promise<void> | void
}

const Alert: React.FC<AlertProps> = ({
    trigger,
    title = 'Are you sure?',
    description = 'This action cannot be undone.',
    confirmLabel = 'Continue',
    cancelLabel = 'Cancel',
    onConfirm,
}) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [open, setOpen] = useState(false);

    const handleConfirm = async () => {
        try {
            setIsProcessing(true);
            await onConfirm?.();
        } finally {
            setOpen(false);
            setIsProcessing(false);
        }
    }

    return (
        <AlertDialog open={open} onOpenChange={setOpen}>
            <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                    <AlertDialogDescription>{description}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel 
                    className='cursor-pointer'
                    disabled={isProcessing}>
                        {cancelLabel}
                    </AlertDialogCancel>
                    <Button
                    variant="default"

                    onClick={() => {
                        handleConfirm()
                    }}
                    disabled={isProcessing}>
                        {confirmLabel}
                        {isProcessing && <Spinner />}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export default Alert
